import { render } from "./DProfileData.vue?vue&type=template&id=ab5511c2&scoped=true&ts=true"
import script from "./DProfileData.vue?vue&type=script&lang=ts"
export * from "./DProfileData.vue?vue&type=script&lang=ts"

import "./DProfileData.vue?vue&type=style&index=0&id=ab5511c2&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5511c2"]])

export default __exports__